enum FunctionEnum {
    FN_RINNOVO_SIM = "FN_RINNOVO_SIM",
    FN_NO_ALLEGATI_SIM = "FN_NO_ALLEGATI_SIM",
    FN_NO_1104_SIM = "FN_NO_1104_SIM",
    FN_NO_IMPORTO_RATA = "FN_NO_IMPORTO_RATA",
    FN_SELECT_FILIALE_SIM = "FN_SELECT_FILIALE_SIM",
    FN_VISIBILITA_ID_105_SIM = "FN_VISIBILITA_ID_105_SIM",
    FN_SELECT_SESSO_SIM = "FN_SELECT_SESSO_SIM",
    FN_BPP = "FN_BPP",
    FN_PREV_VISIBILITA_DATI_MINIMA_SIM = "FN_PREV_VISIBILITA_DATI_MINIMA_SIM",
    FN_VERIFICA_INPS = "FN_VERIFICA_INPS",
}

export default FunctionEnum;
